import React from "react";

const Section = ({ title, icon, children }) => (
  <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300">
    <div className="flex items-center mb-4">
      <span className="text-3xl mr-3">{icon}</span>
      <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>
    </div>
    <div className="text-gray-700 space-y-3 text-sm md:text-base">
      {children}
    </div>
  </div>
);

const ClientTransferGuidelines = () => {
  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "40px 16px" }}>
  <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
      <h1 className="text-4xl font-bold text-center text-gray-900">
        Client Transfer Guidelines
      </h1>

      <p className="text-lg text-center text-gray-700">
        Client Exchange™ is a verified contractor marketplace that facilitates
        the structured sale or swap of active service clients between
        professional businesses. These guidelines outline recommended professional standards
for businesses using the platform when listing, purchasing,
and transferring service clients.
      </p>

      <div className="grid gap-6 md:grid-cols-2">

       <Section title="Before Listing a Client or Service" icon="📋">
  <p>• Only list active recurring services that you have the right to transfer.</p>
  <p>• Ensure you have discussed the potential transfer with your client and that they are aware of, and open to, a contractor change where required.</p>
  <p>• Ensure pricing, service frequency, and suburb/postcode details are accurate at the time of listing.</p>
  <p>• Clearly disclose any known service considerations (access requirements, special conditions, irregular schedules).</p>
  <p>• Do not misrepresent revenue, number of visits, or service history.</p>
  <p>• Do not list clients that have already been cancelled, are under dispute, or have indicated they do not wish to continue service.</p>
  <p>• Listings must reflect genuine intent to complete a structured transfer through Client Exchange™.</p>
</Section>

        <Section title="Before Purchasing" icon="🔍">
          <p>• Review all listing details carefully before payment.</p>
          <p>• Ensure the location fits your service area and capacity.</p>
          <p>• Understand that client retention depends on your service quality.</p>
          <p>• Future revenue is not guaranteed by the platform.</p>
        </Section>

        <Section title="Platform Payment & Handover Process" icon="💳">
          <p>• All payments must be completed through Client Exchange™.</p>
          <p>• Do not arrange payment outside the platform.</p>
          <p>• Seller must professionally introduce the new contractor to the client.</p>
          <p>• Handover must be confirmed within the platform once both participating businesses confirm that the client introduction and transfer have been completed.</p>
          <p>• Platform logs record confirmation activity for transparency.</p>
        </Section>

       <Section title="Professional Conduct Requirements" icon="🏆">
  <p>• Maintain respectful communication between businesses.</p>
  <p>• Do not pressure clients or mislead buyers.</p>
  <p>• Do not arrange private transactions outside the platform after initiating contact through Client Exchange™.</p>
  <p>• All payments and handover confirmations must be completed within the platform.</p>
  <p>• Verified status may be suspended for misconduct or misuse of the system.</p>
</Section>

<Section title="Platform Oversight" icon="📞">
  <p>
    From time to time, Client Exchange™ may contact participating businesses
    during or after the handover process to ensure the platform is functioning
    as intended and to gather feedback.
  </p>
  <p>
    This contact does not constitute involvement in the underlying business
    relationship but helps maintain marketplace standards and quality.
  </p>
</Section>

      </div>

      <div className="bg-gray-50 p-6 rounded-2xl border border-gray-200">
        <h3 className="text-xl font-semibold text-gray-800 mb-3">
          Important Platform Notice
        </h3>
        <p className="text-gray-700 text-sm md:text-base">
          Client Exchange™ verifies business identity but does not guarantee
          future income, client retention, or business performance. The
          platform facilitates structured transfers between verified
          contractors. Ongoing service relationships remain the responsibility
          of the participating businesses.
        </p>
      </div>

      <p className="text-center text-gray-800 font-semibold text-lg">
        Use of Client Exchange™ constitutes agreement to follow these
        guidelines.
      </p>
        </div>
  </div>
  );
};

export default ClientTransferGuidelines;